import React from "react";

import { Box, LinearProgress } from "@mui/material";
import { Fade } from "@mui/material";

import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

import { ThemeProvider } from "@mui/material/styles";
import theme from "../ThemeSettings/Theme";

import PageTop from "./PageTop";
import PageLogo from "./PageLogo";
import Footer from "./Footer";

import { isMobile } from "react-device-detect";

type PageProps = {
  pageLoading: boolean;
  noTop?: boolean;
  noLogo?: boolean;
  noFooter?: boolean;
  children?: React.ReactNode;
};

function Page(props: PageProps) {
  return (
    <Box
      sx={{
        minWidth: "100vw",
        minHeight: "100lvh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "center",
        gap: 4,
        background: theme.palette.background.default,
      }}
    >
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <ThemeProvider theme={theme}>
          <link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Roboto:300,400,500,700&display=swap" />
          {/*Apply the theme to the whole app*/}
          {props.noTop === true ? null : <PageTop />}
          {props.noLogo === true ? null : <PageLogo />}
          {props.pageLoading ? (
            <Fade
              in={props.pageLoading}
              style={{
                transitionDelay: props.pageLoading ? "250ms" : "0ms",
              }}
              unmountOnExit
            >
              <Box sx={{ width: "30%" }}>
                <LinearProgress
                  color="primary"
                  style={{
                    height: 10,
                  }}
                />
              </Box>
            </Fade>
          ) : (
            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 2 }}>{props.children}</Box>
          )}
          {props.noFooter === true ? null : isMobile ? (
            <>
              <Box sx={{ flexGrow: 1, flexShrink: 1 }} />
              <Footer />
            </>
          ) : (
            <Footer />
          )}
        </ThemeProvider>
      </LocalizationProvider>
    </Box>
  );
}

export default Page;
